import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['modal'];
    static values = {
        index: String,
        carouselId: String,
    };

    splide;

    open(event) {
        this.modalTarget.style.display = 'flex';

        if (this.splide == null) {
            this.splide = new Splide(`#${this.carouselIdValue}`, {
                perPage: 1,
                perMove: 1,
                start: event?.params?.index - 1 ?? 0,
                lazyLoad: 'sequential',
                rewind: true,
                rewindByDrag: true,
                pagination: true,
                arrows: false,
                classes: {
                    page: 'splide__pagination__page bg-content-quiet',
                },
            });

            this.splide.mount();
        } else {
            if (event.params.index) {
                this.splide.go(event.params.index - 1);
            }
        }
        setTimeout(() => this.modalTarget.focus(), 0);

        document.body.style.overflow = 'hidden';
    }

    close(event) {
        const clickedElement = event.target;
        const isImgElement = clickedElement.tagName === 'IMG';

        if (!isImgElement) {
            this.modalTarget.style.display = 'none';

            document.body.style.overflow = '';
        }
    }

    next(event) {
        event.stopPropagation();
        this.splide.go('>');
    }

    prev(event) {
        event.stopPropagation();
        this.splide.go('<');
    }
}
